<template>
  <Modal v-model="addCustomersModal" class-name="distributorsStyle" :title="distributorsTitle" width="600"
    :transfer="false" :mask-closable="false" @on-visible-change="distributorsModalChange">
    <Tabs type="card" v-model="tongtuMerchantsTab" :animated="false">
      <TabPane :label="$t('key1003216')" name="NoTongtuMerchants">
        <distributorsForm
          ref="distributors"
          :showProductWholesaleModel="showProductWholesaleModel"
          :countrysBasisData="countrysBasisData"
          :distributorsType="distributorsType">
        </distributorsForm>
      </TabPane>
      <TabPane :label="$t('key1003217')" name="TongtuMerchants">
        <Form ref="tongtuMerchantForm" :model="tongtuMerchantForm" :rules="tongTuRuleValidate"
          :label-width="120" :disabled="distributorsType === 'look'" @submit.native.prevent>
          <Row>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1000017')" prop="merchantId">
                <Input clearable :disabled="distributorsType !== 'add'"
                  v-model.trim="tongtuMerchantForm.merchantId"></Input>
              </Form-item>
            </Col>
          </Row>
        </Form>
      </TabPane>
    </Tabs>
    <template #footer>
      <Button @click="addCustomersModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="distributorsBtn" :disabled="!getPermission('ymsDistributorMerchant_create')"
        v-if="distributorsType === 'add' || (distributorsType === 'edit' && tongtuMerchantsTab === 'NoTongtuMerchants')">
        {{ $t('key1000111') }}
      </Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import distributorsForm from "@/views/yms/components/customerManage/distributorsForm";
import {getAllCountrysData, getAreaCodeByCountryCode, getCustomerLevelAll, getEnableWarehouseData} from "@/utils/common";

export default {
  name: "addCustomersModal",
  mixins: [Mixin],
  props: {
    // 是否开启批发模式
    showProductWholesaleModel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      addCustomersModal: false,
      distributorsTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003202'),
      distributorsType: 'add',
      tongtuMerchantsTab: 'NoTongtuMerchants',
      tongtuMerchantForm: {
        merchantId: ''
      },
      tongTuRuleValidate: {  // 新增客户(通途商户)字段必填的校验
        merchantId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003214'), trigger: 'blur'}
        ]
      },
      countrysBasisData: []
    };
  },
  methods: {
    // 初始化客户
    initCustomersData(type) {
      let obj = {
        add: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003202')
      };
      this.distributorsType = type;
      this.distributorsTitle = obj[type];
      (async () => {
        await getAllCountrysData('en').then((data) => {
          this.countrysBasisData = data;
        });
        await getCustomerLevelAll().then((data) => {
          this.$refs['distributors'].distributorlevelList = this.handleMultilinguaTableFields(data, ['name']);
        });
        // 获取当前已启用的仓库
        await getEnableWarehouseData(1).then((data) => {
          if (data && data.length > 0) {
            this.$refs['distributors'].warehouseList = data;
          }
        });
        this.$refs['distributors'].init();
        this.addCustomersModal = true;
      })();
    },

    // 新增客户确定按钮
    distributorsBtn() {
      let v = this;
      let url = '';
      let method = 'post';
      let text = '';
      // 非通途商户
      if (v.tongtuMerchantsTab === 'NoTongtuMerchants') {
        let {merchantType, ...obj} = v.$refs['distributors'].distributorsForm;

        let ymsDistributorWarehouseOperList = [];
        let ymsWarehouseIdsList = v.$refs['distributors'].distributorsForm.ymsDistributorWarehouseOperList;

        // 新增客户
        if (v.distributorsType === 'add') {
          url = api.post_ymsDistributorMerchant_create;
          method = 'post';
          text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001488');
          ymsWarehouseIdsList.map((item) => {
            ymsDistributorWarehouseOperList.push({
              ymsWarehouseId: item
            });
          });
          obj.saveYmsMerchantTypeRelationBos = [{
            merchantType: merchantType
          }];
        }
        obj.mobileCountryCode = getAreaCodeByCountryCode(v.countrysBasisData, v.$refs['distributors'].distributorsForm.mobileCountryCode);
        obj.ymsDistributorWarehouseOperList = ymsDistributorWarehouseOperList;
        v.$refs['distributors'].$refs['distributorsForm'].validate((valid) => {
          if (valid) {
            v.axios[method](url, obj, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.addCustomersModal = false;
                v.$Message.success(text);
                v.$emit('updateData', true);
              }
            });
          }
        });
      }
      // 通途商户
      else if (v.tongtuMerchantsTab === 'TongtuMerchants') {
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489');
        v.$refs['tongtuMerchantForm'].validate((valid) => {
          if (valid) {
            v.axios.put(api.put_ymsDistributorMerchant_settleIn + `?merchantId=${v.tongtuMerchantForm.merchantId}`).then(response => {
              if (response.data.code === 0) {
                v.addCustomersModal = false;
                v.$Message.success(text);
                v.$emit('updateData', true);
              }
            });
          }
        });
      }
    },

    // 监听新增客户弹窗
    distributorsModalChange(value) {
      if (!value) {
        this.$refs['distributors'].$refs['distributorsForm'].resetFields();
        this.distributorsType = 'look';
        this.tongtuMerchantsTab = 'NoTongtuMerchants';
        this.distributorsTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003215');
        this.$refs['distributors'].distributorsForm.ymsDistributorMerchantGradeId = null;
      }
    },
  },
  components: {
    distributorsForm
  }
};
</script>

<style lang="less" scoped>
/deep/ .distributorsStyle {
  .ivu-input-wrapper-default {
    width: 80%;
  }

  .ivu-input {
    height: 35px;
    line-height: 35px;
  }
}
</style>
